import Stocklocation from 'features/stock/types/stock-location';
import {api} from 'services/api';
import {ObjectId} from 'types/object-id';
import {Option} from 'types/option';
import {ResponseData} from 'types/response-data';

const updateLocation = api.injectEndpoints({
  endpoints: builder => ({
    updateLocation: builder.mutation<Response, updateLocationRequest>({
      query: params => {
        return {
          method: 'PUT',
          url: `stock-locations/${params.id}`,
          body: {
            name: params.name,
            stock_location_category_id: params.stock_location_category?.id,
            is_locked: params.is_locked,
          },
        };
      },
    }),
  }),
});

export type updateLocationRequest = {
  id: ObjectId;
  name: string;
  stock_location_category: Option;
  is_locked: boolean;
};

type Response = ResponseData<Stocklocation>;

export const {useUpdateLocationMutation} = updateLocation;
